import { TextInput as MantineTextInput, TextInputProps } from '@mantine/core';

export type ITextInputProps = TextInputProps;

/** @registry Design-layer pass-through over Mantine TextInput; import this instead of @mantine/core TextInput outside src/design. Extend here when TextInput needs house behavior. */
export const TextInput = MantineTextInput;
